import { MaskedLines } from "./motion";
import { Eyebrow, Breadcrumbs, PrimaryCta, SecondaryCta } from "./ui-bits";

export default function PageHero({ eyebrow, title, lead, crumbs, cta = null, testid, aside = null }) {
  const lines = Array.isArray(title) ? title : [title];
  const id = testid || "page-hero";
  return (
    <section className="relative bg-navy-deep overflow-hidden" data-testid={id}>
      <div className="absolute inset-0 bg-contours-dark" aria-hidden="true" />
      <div className="absolute -top-32 -right-32 h-96 w-96 rounded-full bg-aqua/10 blur-3xl" aria-hidden="true" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 lg:pt-40 pb-16 lg:pb-24 relative">
        {crumbs && (
          <div className="mb-8">
            <Breadcrumbs items={crumbs} dark />
          </div>
        )}
        <div className={aside ? "grid lg:grid-cols-[1.15fr_0.85fr] gap-12 lg:gap-16 items-center" : ""}>
          <div className="max-w-3xl">
            {eyebrow && <Eyebrow dark>{eyebrow}</Eyebrow>}
            <MaskedLines
              as="h1"
              lines={lines}
              delay={0.1}
              className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.08] text-white"
              lineClass="text-white"
            />
            {lead && <p className="mt-6 text-lg leading-relaxed text-white/70">{lead}</p>}
            {cta && (
              <div className="mt-9 flex flex-wrap gap-4">
                <PrimaryCta to={cta.to} dark testid={cta.testid}>{cta.label}</PrimaryCta>
                {cta.secondary && <SecondaryCta to={cta.secondary.to} dark testid={cta.secondary.testid}>{cta.secondary.label}</SecondaryCta>}
              </div>
            )}
          </div>
          {aside && (
            <div className="hidden lg:block" data-testid={`${id}-aside`}>
              <div className="relative bg-navy/70 backdrop-blur-sm border border-navy-light rounded-md p-8 overflow-hidden">
                <div className="absolute inset-0 bg-contours-dark opacity-70" aria-hidden="true" />
                <span className="absolute top-3 right-4 font-mono text-[9px] tracking-[0.3em] text-white/25" aria-hidden="true">GEODRAFTS</span>
                <div className="relative">
                  {aside.kicker && (
                    <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-aqua">{aside.kicker}</p>
                  )}
                  <p className="mt-3 font-display text-2xl font-bold text-white leading-snug">{aside.line}</p>
                  <ul className="mt-6 space-y-3.5">
                    {(aside.points || []).map((p) => (
                      <li key={p} className="flex items-start gap-3">
                        <span className="mt-2 h-1.5 w-1.5 rotate-45 bg-aqua shrink-0" aria-hidden="true" />
                        <span className="text-sm text-white/70 leading-relaxed">{p}</span>
                      </li>
                    ))}
                  </ul>
                  {aside.foot && (
                    <p className="mt-7 pt-4 border-t border-navy-light font-mono text-[10px] uppercase tracking-[0.22em] text-aqua/70">{aside.foot}</p>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
